import { FC, ReactNode } from 'react'
import Box from '@mui/material/Box'
import { Loading } from './Loading'

export interface PendableProps {
    pending: boolean
    children: ReactNode
    cover?: boolean
    id?: string
}

/**
 * Component to display 'loading' state on component (we wrap component with it)
 * @param pending - when we should show the 'loading' state
 * @param children - component to wrap around
 * @param cover - whether we should show component covered with shadow and 'loading' spinner on it, otherwise spinner replaces component
 * @param id
 */
const Pendable: FC<PendableProps> = ({ pending, children, cover, id }) => {
    return !cover ? (
        pending ? (
            <Loading loading={pending} data-test-id={id ? `pendable-${id}` : undefined} />
        ) : (
            <>{children}</>
        )
    ) : (
        <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
            {children}
            {pending && (
                <Box
                    sx={{
                        position: 'absolute',
                        inset: 0,
                        zIndex: 1,
                    }}
                >
                    <Loading loading={pending} data-test-id={id ? `pendable-${id}` : undefined} />
                </Box>
            )}
        </Box>
    )
}

export default Pendable
